import { StatusOptionWithVariantRequired } from '../../utils'

export enum ReportStatusEnum {
  DRAFT = 'DRAFT',
  SENT = 'SENT',
  VALIDATED = 'VALIDATED'
}

export const reportStatusEnumMapping: Record<ReportStatusEnum, StatusOptionWithVariantRequired> = {
  DRAFT: { label: 'report.status.enum.DRAFT', variant: 'danger' },
  SENT: { label: 'report.status.enum.SENT', variant: 'warning' },
  VALIDATED: { label: 'report.status.enum.VALIDATED', variant: 'success' }
}
